import mapValues from 'lodash/mapValues';

const _mapValues = mapValues
export default _mapValues;
